import styled from 'styled-components';

export const SpaAvailabilityWrapper = styled.div`
  padding: 0px 0;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

export const MultipleOptionsAvailabilityWrapper = styled.div`
  padding: 10px 0;
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  gap: 10px;
  margin-bottom: 10px;
`;

export const TitleWrapper = styled.div`
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: 20px;
  white-space: nowrap;
  align-items: center;
`;

export const DividerLine = styled.div`
  height: 1px;
  border-top: 1px solid ${({ theme }) => theme.defaultColors.lightGrey};
`;

export const DropdownGridWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;

  @media (min-width: 600px) {
    grid-template-columns: 1fr 1fr;
  }
`;

export const SubtitleWrapper = styled.div`
  color: ${({ theme }) => theme.defaultColors.grey};
`;

export const DropdownWrapper = styled.div`
  grid-column: 1;

  @media (min-width: 600px) {
    grid-column: 2;
  }
`;
